import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  DevFlags = 'DevFlags',
}

export type DevFlagsMap = Record<DevFlag, boolean>;
export const DEV_FLAGS = new InjectionToken<DevFlagsMap>('DevFlagsMap');

export enum DevFlag {
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  EventDebug = 'debug_event_tracking',
  Hotjar = 'hotjar',
  SharedMailbox = 'shared_mailbox',
  SharedMailboxAutomatedActions = 'shared_mailbox_aa',
  NewTalentPools = 'new_talent_pools',
  PP24Enabled = 'pp24_enabled',
  VonqContracts = 'vonq_contracts',
  ManageLocationsSearchFilters = 'manage_locations_search_filters_flag',
  Views = 'views',
  TellentSas = 'tellent_sas',
  CandidateProfileRefresh = 'candidate_profile_refresh',
  LinkedInRSC = 'linkedin_rsc',
  AnonymousCandidates = 'anonymous_candidates',
  ViewsCandidates = 'views_candidates',
  ViewsPinnedFilters = 'views_pinned_filters',
}
